<template>
    <button
        class="btn btn-md is-ghost btn-block"
        :class="[{ 'is-loading': loading }, buttonSizeClass]"
        @click="deleteAnonymizationRequest"
    >
        <slot />
    </button>
</template>
<script>
    export default {
        props: {
            anonymizationRequest: {
                type: Object,
                required: true,
            },
            size: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            buttonSizeClass() {
                return this.size ? 'btn-' + this.size : null;
            },
        },

        methods: {
            deleteAnonymizationRequest() {
                this.loading = true;
                axios.delete(route('api.gdpr.anonymization-requests.destroy', this.anonymizationRequest.id))
                    .then(() => {
                        this.$emit('deleted');
                    }).catch(() => {
                        flash_error('Åtgärden misslyckades.');
                    }).then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>
